// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const BIN_DATA_STEP_SHAPES = [
  {
    stepType: PipelineStepType.BIN_DATA,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      column: {
        kind: 'columnReference',
        required: true,
        inputDataName: 'Input dataset',
        allowMissingColumn: false,
        validationOptions: {
          allowedLeafTypes: [
            LeafType.INTEGER,
            LeafType.DECIMAL,
            LeafType.DATE,
            LeafType.DATETIME
          ]
        }
      },
      numBins: {
        kind: 'integer',
        required: false,
        minValue: 1,
        maxValue: 1000
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
